import Swiper from 'swiper/bundle';

export default class ValuesCarousel {


	// Constructor
	constructor(element) {

		this.element = element;
		this.swiper = new Swiper(this.element.querySelector('.swiper'), {
			centeredSlides: true,
			//grabCursor: true,
			loop: false,
			navigation: {
				nextEl: '.prev-next-buttons--next',
				prevEl: '.prev-next-buttons--prev'
			},
			pagination: {
				el: '.swiper-pagination'
			},
			slidesPerView: 'auto',
			spaceBetween: 0,
			breakpoints: {
				768: {
					loop: true
				}
			}
		});

	}


	// Public Methods
	destroy() {
		this.swiper.destroy();
		delete this.element;
		delete this.swiper;
	}


}
